export const SET_USER_NOTIFICATIONS_LIST = 'SET_USER_NOTIFICATIONS_LIST'
export const SET_USER_ADMIN_NOTIFICATIONS_LIST = 'SET_USER_ADMIN_NOTIFICATIONS_LIST'
export const SET_NOTIFICATIONS_ARE_LOADING = 'SET_NOTIFICATIONS_ARE_LOADING'
export const SET_NOTIFICATION_LIST_CONFIGURATION = 'GET_USER_NOTIFICATIONS_END'
export const SET_UNREAD_NOTIFICATIONS_COUNTER = 'SET_UNREAD_NOTIFICATIONS_COUNTER'
export const SHOW_NOTIFICATION_SNACKBAR = 'SHOW_NOTIFICATION_SNACKBAR'
export const HIDE_NOTIFICATION_SNACKBAR = 'HIDE_NOTIFICATION_SNACKBAR'
